import type { ModuleNav } from '@saas/ui';

/**
 * chat のメニュー。「チャット」= DM とチャンネル（§12.10.2 第 1・第 2 優先。レコード会話はサイドバー内で未読があるときだけ）。
 * badge 'chat.unread' はシェルが GET /conversation/me の conversationBadgeCount()（未読 DM + 自分宛てメンション）を counts に載せると出る。
 * モバイルのタブバーの「チャット」も /chat（DM + チャンネルだけ・05 条件 7）
 */
export const chatNav: ModuleNav = {
  module: 'chat',
  items: [{ label: 'チャット', to: '/chat', icon: 'chat_bubble', permission: ['chat.dm.use', 'chat.channel.read'], badge: 'chat.unread', description: 'DM とチャンネル', newWindow: true }],
  admin: [],
};
